import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

type UseTenantLabelsQueryOptions = {
  enabled?: boolean;
};

export function useTenantLabelsQuery(options?: UseTenantLabelsQueryOptions) {
  const { user } = useAuth();
  const isEnabled = (options?.enabled ?? true) && Boolean(user);

  return useQuery({
    queryKey: tenantQueryKeys.labels(),
    enabled: isEnabled,
    queryFn: () => userService.listLabels(),
  });
}
